import { path, prop } from "ramda";
import { getParameterByName } from '@qdabra/forms-shared/urlHelpers';

import { typeOption } from '../constants/parameterTypes';
import { paramKey } from '../constants/parameterNames';
import { getXmlDateTime } from "../../../utility/date.helpers";


const PROP_USER_AGENT = 'UserAgent';
const PROP_CURRENT_URL = 'CurrentUrl';
const PROP_SITE_COLLECTION_URL = 'SharePointSiteCollectionUrl';
const PROP_SITE_URL = 'SharePointSiteUrl';
const PROP_LAST_MODIFIED = 'LastModified';

var userAgentDescription = PROP_USER_AGENT + ' - The User Agent string of the requesting agent.';
var currentUrlDescription = PROP_CURRENT_URL + ' - The URL of the currently open XML document. This value can change if the form is saved to a new location while it is open.';
var sharePointSiteCollectionUrlDescription = PROP_SITE_COLLECTION_URL + ' - The URL of the SharePoint site collection that the template belongs to.';
var sharePointSiteUrlDescription = PROP_SITE_URL + ' - The URL of the SharePoint site that the template belongs to.';
var lastModifiedDescription = PROP_LAST_MODIFIED + ' - The date and time that the current form template was last modified.';

// options should be listed in alphabetical order of their key value
const options = [
    {
        name: currentUrlDescription,
        value: PROP_CURRENT_URL,
    },
    {
        name: lastModifiedDescription,
        value: PROP_LAST_MODIFIED,
    },
    {
        name: sharePointSiteCollectionUrlDescription,
        value: PROP_SITE_COLLECTION_URL,
    },
    {
        name: sharePointSiteUrlDescription,
        value: PROP_SITE_URL,
    },
    {
        name: userAgentDescription,
        value: PROP_USER_AGENT,
    },
];

const keyParameterDescription = `Name of the property to retrieve. Allowed values for key: (${options.map(prop('value')).join(' | ')})`;

const requiredParameters = [
    {
        name: paramKey,
        description: keyParameterDescription,
        type: typeOption,
        options: options,
    }
];

const description = "Obtain the value of a form property.";


function getValue(key, shpAccess, templateInfo) {

    switch (key) {
        case PROP_USER_AGENT:
            if (!window.navigator || !window.navigator.userAgent) {
                throw new Error('The User Agent is not available.');
            }

            return window.navigator.userAgent;

        case PROP_CURRENT_URL:
            var href = typeof window !== 'undefined' && path(['location', 'href'], window);

            if (!href) {
                throw new Error('The Current URI is not available.');
            }

            return href;

        case PROP_SITE_COLLECTION_URL:
            return shpAccess.getRootSiteUrlAsync()
                .catch(function (error) {
                    throw new Error('The SharePoint Site Collection Url is not currently available. Error: ', error);
                });

        case PROP_SITE_URL:
            var spHostUrl = getParameterByName('SPHostUrl');

            if (!spHostUrl) {
                throw new Error('The SharePoint Site Url is not currently available');
            }

            return spHostUrl;

        case PROP_LAST_MODIFIED:
            var updatedDate = templateInfo.getLastUpdatedDate();

            if (!updatedDate) {
                throw new Error('The Last Modified Date is not currently available');
            }

            return getXmlDateTime(updatedDate);

        default:
            throw new Error(`GetFormProperty: The specified key is invalid: ${key}`);
    }
}

function GetFormProperty(params) {
    async function executeAsync() {
        const cf = params.commonFunctions;
        const key = cf.getParamValue(paramKey);
        const shpAccess = params.shpAccess;
        const templateInfo = params.template;

        return await getValue(key, shpAccess, templateInfo);
    }

    return {
        description,
        executeAsync,
        requiredParameters
    };
}

export default GetFormProperty;